import React from "react";
import { useSelector } from "react-redux";
import RefferalsLanding from "../../components/refferals/RefferalsLanding";
import { selectUser } from "../../components/auth/auth.selector";

const Refferals = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <RefferalsLanding userInfoData={userInfoData} />
  );
};

export default Refferals;
